export default __webpack_public_path__ + "static/media/404-error-pana.0d8272ac.svg";